import { refreshAuthToken, refreshProxyCookie } from "./authService";
import store from "../redux/store";
import { updateTokens, logoutAndClearData } from "../redux/slices/authSlice";

export const authFetch = async (url, options = {}) => {
  const { token, refreshToken } = store.getState().auth.user;

  options.headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  try {
    let response = await fetch(url, options);

    if (response.status === 401 && refreshToken) {
      try {
        await refreshProxyCookie(refreshToken);
        const newTokens = await refreshAuthToken(refreshToken);
        if (newTokens) {
          store.dispatch(updateTokens({ token: newTokens.token, refreshToken: newTokens.refreshToken }));

          // Retry original request with new token
          options.headers.Authorization = `Bearer ${newTokens.token}`;
          response = await fetch(url, options);
        } else {
          throw new Error("Token refresh failed");
        }
      } catch (refreshError) {
        store.dispatch(logoutAndClearData());
        throw refreshError;
      }
    }

    return response;
  } catch (error) {
    console.error("Network or unexpected error:", error.message || error);
    throw error;
  }
};
